import React, { useState,useRef,useEffect, useMemo  } from 'react';
import {getGlobalDiscount} from '../../services/cashFlow/cashFlow'
import { useSweetAlert } from '../sweetAlerts/useSweetAlert';
import {cedimi} from '../../constant/globalConstantsTypeClients';
import moment from 'moment';
import * as XLSX from 'xlsx';
import {getAllBranches } from '../../services/commercialLine/commercialLine'
import { useForm } from '../forms/useForm';
import { sendRequest } from '../requests/useRequest';
import { useHistory } from 'react-router-dom';
import { validarSesion } from '../tokens/useToken';


export const useReportSamplesP = () => {

    // ? REPORT
    const history = useHistory();

    const [createSweet] = useSweetAlert();
    const [loading, setLoading] = useState(false);
    const [reportPendingExams, setReportPendingExams] = useState([]);
    console.log("🚀 ~ useReportSamplesP ~ reportPendingExams:", reportPendingExams)
    const [pedingExam, setPedingExam] = useState([]);
    console.log("🚀 ~ useReportSamplesP ~ pedingExam:", pedingExam)

    const [branches, setBranches] = useState([]);
    let id_branch = localStorage.getItem('branchId');


    const [formValues, handleInputChange, reset, handleUpdateValues, handleSelectValues, handlePickerValues] = useForm({
        mDateRange1: "",
        mDateRange2: "",
        mSelectBranch: null,

    });
    

    const {
        mDateRange1, mDateRange2, mSelectBranch, mSelectSections,

    } = formValues;


    useEffect(() => {
        getBranches();
    }, [])



    //#region Branch 

      useEffect(() => {
        if (branches.length > 0) {

            let _find = branches.find(x => x.value === parseInt(id_branch))
            handleUpdateValues({
                ...formValues,
                mSelectBranch: _find
            });
        }
    }, [branches]);


    const getBranches = async () => {
        const branches = await getAllBranches();
        if (branches !== null && branches.length > 0) {
            // let _allOption = {
            //     value: 0,
            //     label: "TODAS LAS SUCURSALES"
            // };
    
            let _newBranches = []; 
    
            branches.forEach((branch) => {
                _newBranches.push({
                    value: branch.id_branch,
                    label: branch.name
                });
            });
    
            setBranches(_newBranches);
        } else {
            setBranches([]);
        }
    }


    //#region Filters
    
    const getReportPending = (e, search = true) => {
        if (e) e.preventDefault();

        if (search) {
            let query = "";
            let _mfrom = (mDateRange1) ? moment(mDateRange1).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD");
            let _mto = (mDateRange2) ? moment(mDateRange2).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD");
            let _idBranch = mSelectBranch ? mSelectBranch.value : '';


            if (_mfrom !== "") {
                query += `start=${_mfrom}`;
            }

            if (_mto !== "") {
                query += `&end=${_mto}`;  
            }

            if (_idBranch !== "") {
                query += `&id_branch=${_idBranch}`; 
            }


            setLoading(true);

            getReportExamPending(true, query, _idBranch);

        }
    }

    const getReportExamPending = async (_search = false, _filter, _idBranch  = null) => {
        setLoading(true);

        let _listTmp = {};
        let _alterUrl = "";

        if (_search === false) {
            _listTmp = await handleRequest("GET", `Reports/ReportExamsPending?id_branch=${id_branch}` + _alterUrl, 'Report');
        } else {
            _listTmp = await handleRequest("GET", `Reports/ReportExamsPending?${_filter}`, 'Report');
        }

        const exams = Array.isArray(_listTmp.data) ? _listTmp.data : (Array.isArray(_listTmp) ? _listTmp : []);

        const flattened = exams.flatMap(order => {
            let rows = [];

            // Exámenes normales y curvas
            order.traceabilitExams.forEach(exam => {
                if (exam.is_curve && Array.isArray(exam.arrayCurves)) {
                    // Curva
                    rows.push({
                        nim: order.nim,
                        name_patient: order.name_patient,
                        exam_name: exam.name,
                        is_curve: true,
                        is_profile: false,
                        type_exam: 'Curva',
                        center_process: order.center_process ?? true,
                        id_branch_destination: exam.arrayCurves.length > 0 ? exam.arrayCurves[0].id_branch_destination ?? null : null,
           
                        items: exam.arrayCurves.map(curve => ({
                            exam_name: `Toma ${curve.num_samplings}`,
                            barcode: exam.barcode ?? '—',
                            check_forwarded: exam.check_forwarded ?? false,  
                            is_toma: exam.is_toma ?? false,                
                            is_send1: exam.is_send1 ?? false,
                            is_send2: exam.is_send2 ?? false,
                            name_branch_origin: curve.name_branch_origin ?? '—',
                            name_branch_destination: curve.name_branch_destination ?? '—',
                            init_time_procces2: curve.init_time_procces2 ?? '---',
                            init_time_procces3: curve.init_time_procces3 ?? '---',
                            user_process2: curve.user_process2 ?? '---',
                            user_process3: curve.user_process3 ?? '---',
                            init_time_flebo: curve.init_time_flebo ?? '---'
                        }))

                    });
                } else {
                    // Examen normal
                    const sendInfo = exam.traceabilitSend?.[0] || {};
                    rows.push({
                        nim: order.nim,
                        name_patient: order.name_patient,
                        exam_name: exam.name,
                        is_curve: false,
                        is_profile: false,
                        type_exam: 'Exámen',
                        center_process: order.center_process ?? true,
                        id_branch_destination: sendInfo.id_branch_destination ?? null,
                        barcode: exam.barcode ?? '—',
                        check_forwarded: exam.check_forwarded ?? false,
                        is_toma: exam.is_toma ?? false,
                        is_send1: exam.is_send1 ?? false,
                        is_send2: exam.is_send2 ?? false,
                        name_branch_origin: sendInfo.name_branch_origin ?? '—',
                        name_branch_destination: sendInfo.name_branch_destination ?? '—',
                        init_time_procces2: sendInfo.init_time_procces2 ?? '--',
                        init_time_procces3: sendInfo.init_time_procces3 ?? '--',
                        user_process2: sendInfo.user_process2 ?? '--',
                        user_process3: sendInfo.user_process3 ?? '--'
                    });
                }
            });

            // Perfiles
            order.traceabilitProfiles.forEach(profile => {
                rows.push({
                    nim: order.nim,
                    name_patient: order.name_patient,
                    exam_name: profile.name_profile,
                    is_curve: false,
                    is_profile: true,
                    type_exam: 'Perfil',
                    center_process: order.center_process ?? true,
                    id_branch_destination: profile.listExam.length > 0 
                        ? (profile.listExam[0].traceabilitSend?.[0]?.id_branch_destination ?? null)
                        : null,
                    items: profile.listExam.map(exam => {
                        const sendInfo = exam.traceabilitSend?.[0] || {}; 
                        return {
                            exam_name: exam.name,
                            barcode: exam.barcode ?? '—',
                            is_toma: exam.is_toma ?? false,
                            is_send1: exam.is_send1 ?? false,
                            is_send2: exam.is_send2 ?? false,
                            name_branch_origin: sendInfo.name_branch_origin ?? '—',
                            name_branch_destination: sendInfo.name_branch_destination ?? '—',
                            init_time_procces2: sendInfo.init_time_procces2 ?? '---',
                            init_time_procces3: sendInfo.init_time_procces3 ?? '---',
                            user_process2: sendInfo.user_process2 ?? '---',
                            user_process3: sendInfo.user_process3 ?? '---'
                        }
                    })
                });
            });


            return rows;
        });

        // Ajusta este filtro para no perder perfiles y curvas que no tengan id_branch_destination definido
        const filtered = flattened.some(item => item.center_process === false)
            ? flattened.filter(item => {
                if (!item.id_branch_destination) return true; // Incluye si no tiene destino definido
                return item.id_branch_destination == _idBranch;
            })
            : flattened;

        setReportPendingExams(filtered);
        setPedingExam(filtered);

        setLoading(false);
    };


    
    const handleClean = () => {
        const today = moment().format("YYYY-MM-DD");

        handleUpdateValues({
            mDateRange1: "",
            mDateRange2: "",
            mSelectBranch: null
        });

        const query = `start=${today}&end=${today}`;

        setLoading(true);
        getReportExamPending(true, query);
    };


    const handleCleanBranch = () => {
        handleUpdateValues(prev => ({
            ...prev,
            mSelectBranch: null,
        }));

        let query = "";
        let _mfrom = (mDateRange1) ? moment(mDateRange1).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD");
        let _mto = (mDateRange2) ? moment(mDateRange2).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD");
        query += `start=${_mfrom}&end=${_mto}`;

        setLoading(true);
        getReportExamPending(true, query); 
    };

    useEffect (() =>{
        if(mSelectBranch) {
            getReportPending();
        }
    }, [mSelectBranch]);



    //#endregion

   

    //#region GLOBAL REQUEST
    const handleRequest = async (method, methodUrl, nameMethod, body = null) => {
        let requestOptions = {
            method: method
        };

        if (body !== null) {
            requestOptions = {
                ...requestOptions,
                body: JSON.stringify(body)
            };
        }

        const response = await sendRequest(requestOptions, methodUrl);

        if (response.code === 200) {
            return response.data;
        }
        else if (response.code === 401) {
            validarSesion(history, response.code, handleRequest);
        }
        else if (response.code === 500) {
            createSweet("error", "error", nameMethod, "Ocurrio un error en el servidor");
        }
        else {
            createSweet("warning", "warning", nameMethod, response.data.msg);
        }

        return null;
    }

    // #endregion

    //#region Search
    const handleSearch = (e) => {
        let busqueda = e.target.value.toUpperCase();
        let newMethod = [];

        pedingExam.forEach(element => {
            const nim = element.nim?.toString().toUpperCase() || "";
            const barcode = element.barcode?.toUpperCase() || "";

            if (
                nim.includes(busqueda) ||
                barcode.includes(busqueda)
            ) {
                element.visibleTable = true;
                newMethod.push(element);
            }
        });

        setReportPendingExams(newMethod);
    };


    //#endregion
    // #region Excel 
    const exportExcel = () => {
    if (!reportPendingExams || reportPendingExams.length === 0) {
        createSweet("error", "error", "", "No hay datos para exportar");
        return;
    }

    const groupedData = {};

    reportPendingExams.forEach(item => {
        console.log("🚀 ~ exportExcel ~ item:", item)
        const key = item.nim;

        if (!groupedData[key]) {
            groupedData[key] = {
                nim: item.nim,
                name: item.name_patient,
                rows: []
            };
        }

        if (item.is_curve || item.is_profile) {
            item.items.forEach(subItem => {
                console.log("🚀 ~ exportExcel ~ subItem:", subItem)
                groupedData[key].rows.push({
                    exam: subItem.exam_name,
                    etiqueta: subItem.barcode,
                    remitida: item.check_forwarded ? "Sí" : "No",
                    toma: subItem.is_toma ? "Sí" : "No",
                    envio: subItem.init_time_procces2 && subItem.init_time_procces2 !== '---' ? "Sí" : "No",
                    horaEnvio: subItem.init_time_procces2 || '',
                    usuarioEnvio: subItem.user_process2 || '',  
                    recepcion: subItem.init_time_procces3 && subItem.init_time_procces3 !== '---' ? "Sí" : "No",
                    horaRecepcion: subItem.init_time_procces3 || '',
                    usuarioRecepcion: subItem.user_process3 || '', 
                    origen: subItem.name_branch_origin,
                    destino: subItem.name_branch_destination,
                });
            });
        } else {
            // Exámenes 
            groupedData[key].rows.push({
                exam: item.exam_name,
                etiqueta: item.barcode,
                remitida: item.check_forwarded ? "Sí" : "No",
                toma: item.is_toma ? "Sí" : "No",
                envio: item.is_send1 ? "Sí" : "No",
                horaEnvio: item.init_time_procces2 || '',
                usuarioEnvio: item.user_process2 || '',
                recepcion: item.is_send2 ? "Sí" : "No",
                horaRecepcion: item.init_time_procces3 || '',
                usuarioRecepcion: item.user_process3 || '',
                origen: item.name_branch_origin,
                destino: item.name_branch_destination,
            });
        }
    });
    console.log("🚀 ~ exportExcel ~ reportPendingExams:", reportPendingExams)

    const aoa = [
        ['NIM', 'Nombre del Paciente', 'Sucursal Origen', 'Examen', 'Etiqueta', 'Remitida', 'Toma', 'Envío', 'Hora Envío', 'Usuario Envío', 'Recepción', 'Hora Recepción', 'Usuario Recepción', 'Sucursal Destino']
    ];

    const merges = [];
    let currentRow = 1;

    Object.values(groupedData).forEach(item => {
        const { nim, name, rows } = item;

        rows.forEach((row, index) => {
            aoa.push([
                index === 0 ? nim : '',
                index === 0 ? name : '',
                row.origen,
                row.exam,
                row.etiqueta,
                row.remitida,
                row.toma,
                row.envio,
                row.horaEnvio,
                row.usuarioEnvio,
                row.recepcion,
                row.horaRecepcion,
                row.usuarioRecepcion,
                row.destino
            ]);
        });

        if (rows.length > 1) {
            merges.push(
                { s: { r: currentRow, c: 0 }, e: { r: currentRow + rows.length - 1, c: 0 } }, 
                { s: { r: currentRow, c: 1 }, e: { r: currentRow + rows.length - 1, c: 1 } }, 
            );
        }

        currentRow += rows.length;
    });

    const worksheet = XLSX.utils.aoa_to_sheet(aoa);
    worksheet['!merges'] = merges;

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Pendientes');

    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const dataBlob = new Blob([excelBuffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });

    const fileName = 'Trazabilidad.xlsx';

    const url = window.URL.createObjectURL(dataBlob);
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
};



        //#endregion


    const renderStatus = (row) => {
        if (!row) return <span style={{ color: "red", fontSize: "18px" }}>❌</span>;

        const { is_toma, check_forwarded } = row;

        if (is_toma === true || check_forwarded === true) {
            return <span style={{ color: "green", fontSize: "18px" }}>✔</span>;
        }

        return <span style={{ color: "red", fontSize: "18px" }}>❌</span>;
    };


    const renderSend1Status = (row) => {
        if (!row) return <span style={{ color: "red", fontSize: "18px" }}>❌</span>;

        const { is_send1 } = row;

        if (is_send1 === true) {
            return <span style={{ color: "green", fontSize: "18px" }}>✔</span>;
        } else {
            return <span style={{ color: "red", fontSize: "18px" }}>❌</span>;
        }
    };

    const renderSend2Status = (row) => {
        if (!row) return <span style={{ color: "red", fontSize: "18px" }}>❌</span>;

        const { is_send2 } = row;

        if (is_send2 === true) {
            return <span style={{ color: "green", fontSize: "18px" }}>✔</span>;
        } else {
            return <span style={{ color: "red", fontSize: "18px" }}>❌</span>;
        }
    };

        const renderTomaCurves = (row) => {
            if (!row) return <span style={{ color: "red", fontSize: "18px" }}>❌</span>;

            const { is_toma, init_time_procces2 } = row;
            const hasInitTime = init_time_procces2 && init_time_procces2 !== '---';

            if (is_toma === true) {
                return <span style={{ color: "green", fontSize: "18px" }}>✔</span>;
            }

            if (is_toma === false) {
                return hasInitTime
                    ? <span style={{ color: "green", fontSize: "18px" }}>✔</span>
                    : <span style={{ color: "red", fontSize: "18px" }}>❌</span>;
            }

            return <span style={{ color: "red", fontSize: "18px" }}>❌</span>;
        };



        const renderSend1CurvesStatus = (row) => {
            if (!row) {
                return <span style={{ color: "red", fontSize: "18px" }}>❌</span>;
            }

            const hasInitTime = row.init_time_procces2 && row.init_time_procces2 !== '---';

            if (row.is_send1 === false && hasInitTime) {
                return <span style={{ color: "green", fontSize: "18px" }}>✔</span>;
            }

            if (row.is_send1 === null || row.is_send1 === false) {
                return <span style={{ color: "red", fontSize: "18px" }}>❌</span>;
            }

            return <span style={{ color: "green", fontSize: "18px" }}>✔</span>;
        };


        const renderSend2CurvesStatus = (row) => {
            if (!row) {
                return <span style={{ color: "red", fontSize: "18px" }}>❌</span>;
            }

            const hasInitTime = row.init_time_procces3 && row.init_time_procces3 !== '---';

            if (row.is_send2 === false && hasInitTime) {
                return <span style={{ color: "green", fontSize: "18px" }}>✔</span>;
            }

            if (row.is_send2 === null || row.is_send2 === false) {
                return <span style={{ color: "red", fontSize: "18px" }}>❌</span>;
            }

            return <span style={{ color: "green", fontSize: "18px" }}>✔</span>;
        };

            
    
        const colorPalette = [
            "#cce5ff", // azul claro muy suave
            "#99ccff", // azul claro
            "#66b2ff", // azul medio claro
            "#3399ff", // azul estándar
            "#007bff", // azul bootstrap principal
            "#0056b3", // azul oscuro
            "#003d80", // azul muy oscuro
            "#00264d", // azul noche 
        ];
        const nimColors = useMemo(() => {
        const colorMap = {};
        let colorIndex = 0;
        const seen = {};
    
        reportPendingExams.forEach(item => {
            const nim = item.nim;
            if (!seen[nim]) {
            seen[nim] = true;
            colorMap[nim] = colorPalette[colorIndex % colorPalette.length];
            colorIndex++;
            }
        });
    
        return colorMap;
        }, [reportPendingExams]);
    
    const getContrastColor = (bgColor) => {
        const c = bgColor.substring(1);      
        const rgb = parseInt(c, 16);         
        const r = (rgb >> 16) & 0xff;
        const g = (rgb >> 8) & 0xff;
        const b = (rgb >> 0) & 0xff;
        const brightness = (r * 299 + g * 587 + b * 114) / 1000;
        return brightness > 125 ? '#000' : '#fff'; 
    };
    
    


    return {

        //Filter
        mDateRange1, mDateRange2, mSelectBranch, branches, reportPendingExams, getReportPending,
        handleInputChange, handleSelectValues, handleCleanBranch, handleClean, handleSearch,
        loading,exportExcel,

        renderStatus, renderSend1Status, renderSend2Status, nimColors, getContrastColor, 
        renderSend1CurvesStatus, renderSend2CurvesStatus, renderTomaCurves


    }
}
   
